//import { FMCAccordion } from './AccordionComponent'
import { FMCAccordion } from '@ford/ford-design-system';
import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../Components/Button/Button';
import Label from '../../../Components/Label/Label';
import RadioButton from '../../../Components/RadioButton/RadioButton';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import { getCall } from '../../../Services/CommonService';

import PropTypes from 'prop-types';

import { useNavigate, useParams } from 'react-router-dom';


const Accordion = (props) => {
  const initialized = useRef(false);
  const accordionRef = useRef();
  const [propStatSelect, setPropStatSelect] = useState({});

  const handleRadioChange = (event) => {
    setPropStatSelect((prevState) => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };
  const navigate = useNavigate();

  let updateButton = null;
  const assinmentupdate = (bpiNb) => {
    console.log("button clicked in accordian",bpiNb);
    navigate('/assignmentdetailsUpdate/'+bpiNb);


  };
  const personalPropClick = (bpiNb) => {
    if (propStatSelect[bpiNb] !== 'R' && propStatSelect[bpiNb] !== 'D') {
      swal('', 'Must select Returned or Disposed to update', 'warning');
    } else {
      Promise.all([
        getCall(
          'processProperty/updatePrsnPrptyStat' +
          '?bpiNb=' +
          bpiNb +
          '&cntrctrNb=' +
          props.userInfo.cntrctrNb +
          '&propStatCd=' +
          propStatSelect[bpiNb] +
          '&userId=' +
          props.userInfo.userId
        ),
        getCall(
          'processProperty/updatePrsnPrptyFupStat' +
          '?bpiNb=' +
          bpiNb +
          '&propStatCd=' +
          propStatSelect[bpiNb] +
          '&userId=' +
          props.userInfo.userId
        ),
      ])
        .then(([personalProperty, followUp]) => {
          console.log('Personal Property API Calls finished');
          console.log(personalProperty);
          console.log(followUp);
          swal('', 'Success', 'success');
        })
        .catch(() => {
          console.log('Error calling updatePrsnPrptyStat or updatePrsnPrptyFupStat');
          swal('', 'Error', 'error');
        });
    }
  };
  // inside your component (but outside the JSX return)
  const renderUpdateButton = (panel, account, userInfo) => {
    if (panel.name === 'Active') {
      return (
        <Button
          label="Update"
          onClick={() => assinmentupdate(account.teamWrkBpiNb)}
        />
      );
    }

    if (panel.name === 'Personal Property' && userInfo.rdnInd === 0) {
      return (
        <Button
          label="Update"
          onClick={() => personalPropClick(account.teamWrkBpiNb)}
        />
      );
    }

    return null;
  };


  useEffect(() => {
    const personalPropertyPanel = props.panels.find(
      (panel) => panel.name === 'Personal Property'
    );

    if (!personalPropertyPanel) return;

    personalPropertyPanel.accounts.forEach((account) => {
      setPropStatSelect((prevState) => ({
        ...prevState,
        [account.teamWrkBpiNb]: { propStatCd: '', invalid: null },
      }));
    });

    if (!initialized.current) {
      initialized.current = true;
      let x = new FMCAccordion(accordionRef.current);
      console.log(x);
    }
  }, [props.panels]);

  const rbOptions = [
    { name: 'Returned', value: 'R' },
    { name: 'Disposed', value: 'D' },
  ];

  return (
    <div ref={accordionRef} className="js-fmc-accordion fmc-accordion fds-color__bg--light">
      {props.panels > 0
        ? 'Loading...'
        : props.panels.map((panel) => (
          <div className="fmc-accordion__panel" key={panel.name}>
            <button
              type="button"
              className="fmc-accordion__button"
              id="panel-1-button"
              aria-controls="panel-1-content"
            >
              <span className="fmc-accordion__button-title">{panel.name}</span>
              <span className="fmc-accordion__button-expand fds-icon"></span>
            </button>
            <div className="fmc-accordion__body">
              <div
                className="fmc-accordion__content"
                aria-labelledby="panel-1-button"
                id="panel-1-content"
                aria-label="region"
                aria-hidden="false"
              >
                <table className="fmc-type--body1 panelTable">
                  <colgroup>
                    <col style={{width: '15%'}} />
                    <col style={{width: '35%'}} />
                    <col style={{width: '10%'}} />
                    <col style={{width: '30%'}} />
                    <col style={{width: '10%'}} />
                  </colgroup>
                  <thead>
                  <tr>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Vehicle Info</th>
                    <th>VIN</th>

                  </tr>

                  </thead>
                  {panel.accounts.map((account) => (
                    <tbody key={account.teamWrkBpiNb}>
                    <tr>
                      {panel.name === 'Active' && props.userInfo.rdnInd === 0 ? (
                        <>
                          <td className="dateCol">
                            <Link to={`/main/${account.teamWrkBpiNb}`}>{account.cntrctrAcptDt}</Link>
                          </td>
                          <td className="nameCol">
                            <Link to={`/main/${account.teamWrkBpiNb}`}>{account.lastNm}</Link>
                          </td>
                          <td className="numCol">
                            <Link to={`/main/${account.teamWrkBpiNb}`}>{account.custAcctNb}</Link>
                          </td>
                          <td className="vehCol">
                            <Link to={`/main/${account.teamWrkBpiNb}`}>
                              <span>{account.vehMdlYr}</span>&nbsp;
                              <span>{account.vehColorTx}</span>&nbsp;
                              <span>{account.makeDescTx}</span>&nbsp;
                              <span>{account.mdlDescTx}</span>
                            </Link>
                          </td>
                          <td className="vinCol">
                            <Link to={`/main/${account.teamWrkBpiNb}`}>{account.vinSerialNb}</Link>
                          </td>
                          {/*<td className="">*/}
                          {/*  <fmc-button label="Update" onClick={assinmentupdate(account.teamWrkBpiNb)}></fmc-button>*/}
                          {/*</td>*/}
                        </>
                      ) : (
                        <>
                          {panel.name === 'Recently Grounded & Submitted' ? (
                            <td className="dateCol">{account.grndDt}</td>
                          ) : (
                            <td className="dateCol">{account.cntrctrAcptDt}</td>
                          )}
                          <td className="nameCol">{account.lastNm}</td>
                          <td className="numCol">{account.custAcctNb}</td>
                          <td className="vehCol">
                            <span>{account.vehMdlYr}</span>&nbsp;
                            <span>{account.vehColorTx}</span>&nbsp;
                            <span>{account.makeDescTx}</span>&nbsp;
                            <span>{account.mdlDescTx}</span>
                          </td>
                          <td className="vinCol">{account.vinSerialNb}</td>
                        </>
                      )}
                      <td>
                        {renderUpdateButton(panel, account, props.userInfo)}
                      </td>
                    </tr>
                    {panel.name === 'Personal Property' && (
                      <tr>
                        <td></td>
                        <td></td>
                        <td colSpan="2">
                          <Label text="Property: " /> State: {account.vehRcvrdStAbbrCd} Age: {account.age}
                        </td>
                        <td>
                          {props.userInfo.rdnInd === 0 && (
                            <RadioButton
                              label=""
                              options={rbOptions}
                              groupName={`${account.teamWrkBpiNb}`}
                              radioVal={propStatSelect[`${account.teamWrkBpiNb}`]}
                              className="fmc-check--horizontal marginMinus20"
                              onChange={handleRadioChange}
                            />
                          )}
                        </td>
                        <td></td>
                      </tr>
                    )}
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

Accordion.propTypes = {
  userInfo: PropTypes.shape({
    userId: PropTypes.string,
    cntrctrNb: PropTypes.any,
    rdnInd: PropTypes.any,
  }),
  panels: PropTypes.array,
  rdnInd: PropTypes.any,
};

export default Accordion;
